/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Preview_SearchInputs */

const en_landing_preview_search = /** @type {(inputs: Landing_Preview_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search research`)
};

/**
* | output |
* | --- |
* | "Search research" |
*
* @param {Landing_Preview_SearchInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_preview_search = /** @type {((inputs?: Landing_Preview_SearchInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Preview_SearchInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_preview_search(inputs)
});